import React from "react";

import CatalogCrudPage from "./CatalogCrudPage";
import { familiesService } from "../../services";

export default function FamiliesPage() {
  return (
    <CatalogCrudPage
      title="Familias"
      subtitle="Administracion de familias de productos"
      addTabPath="/settings/families"
      addTabLabel="Familias"
      service={familiesService}
      hasDescription
      viewPerms={["view_families"]}
      managePerms={["manage_families"]}
    />
  );
}
